
import { api } from "../utils/axios";

// Fetch notifications with pagination and filter
export const fetchNotifications = async (page = 1, limit = 20, read = undefined) => {
    try {
        let query = `?page=${page}&limit=${limit}`;
        if (read !== undefined) query += `&read=${read}`;

        const response = await api.get(`/notifications${query}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching notifications:", error);
        throw error;
    }
};

// Mark single notification as read
export const markNotificationRead = async (id) => {
    try {
        const response = await api.patch(`/notifications/${id}/read`);
        return response.data.data;
    } catch (error) {
        console.error("Error marking notification read:", error);
        throw error;
    }
};

// Mark all as read
export const markAllNotificationsRead = async () => {
    try {
        const response = await api.patch(`/notifications/read-all`);
        return response.data.data;
    } catch (error) {
        console.error("Error marking all read:", error);
        throw error;
    }
};

// Delete notification
export const deleteNotification = async (id) => {
    try {
        await api.delete(`/notifications/${id}`);
        return true;
    } catch (error) {
        console.error("Error deleting notification:", error);
        throw error;
    }
};

// Clear all notifications
export const clearAllNotifications = async () => {
    try {
        await api.delete(`/notifications/clear-all`);
        return true;
    } catch (error) {
        console.error("Error clearing all notifications:", error);
        throw error;
    }
};
